import PromotionsNotifications from './PromotionsNotifications';

export default PromotionsNotifications;
